module.exports = __webpack_public_path__ + "881c86876af63b732063d7bdd51bb226.png";